import CartItem from '@/classes/CartObject';

class SkiPassAccomodationCartItem extends CartItem {
  type = 'SKIPASS-ACCO';

  adults = 0;
  youths = 0;
  children = 0;
  seniors = 0;

  adultsPrice = 0;
  youthsPrice = 0;
  childrenPrice = 0;
  seniorsPrice = 0;

  days = 0;

  editing = false;

  constructor() {
    super();
    return true;
  }
}

export default SkiPassAccomodationCartItem;



// WEBPACK FOOTER //
// ./src/classes/SkiPassAccomodationCartItem.js